// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__SxUMv","screen":"styles_screen__3W82C","loader":"styles_loader__2aFki","navBar":"styles_navBar__2XSGJ","content":"styles_content__3p47D"};